// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1okW0","title":"Header_title__En5Rl","left":"Header_left__W-0YG","clinicName":"Header_clinicName__1DyWA"};